import React, { useState } from 'react';
import { getSkillDescription, getUserId, GLOBAL_COLORS } from '../../hooks';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { addHighlightedSkillAPI, addSelfReportedSkillAPI } from '../../hooks';
import { LiaTimesSolid } from 'react-icons/lia';

export const SkillsPopup = (props) => {
  const [sliderValue, setSliderValue] = useState([
    1,
    props.skillsData.starCount,
  ]);
  const [isPopupOpen, setPopupOpen] = useState(true);
  const [selectedSkillDescription, setSelectedSkillDescription] = useState(
    getSkillDescription(props.skillsData.starCount)
  );

  const handleSliderChange = (sliderValue) => {
    setSliderValue(sliderValue);
    setSelectedSkillDescription(getSkillDescription(sliderValue[1]));
  };

  const handlePopupClose = () => {
    setPopupOpen(false);
    props.closePopUp();
  };

  const removeSkill = (data, skillName) => {
    return data.filter((skill) => skill.name !== skillName);
  };

  const formatSkillData = (filteredData) => {
    const userId = getUserId();

    const hasStarCount = filteredData.some(
      (skill) => typeof skill.starCount !== 'undefined'
    );

    return {
      user_id: userId,
      skills: filteredData.map((skill) => skill.name),
      ...(hasStarCount && {
        data: {
          level: filteredData.map((skill) => skill.starCount),
        },
      }),
    };
  };

  const changeSkillRating = (skillName, skillRating) => {
    return props.allSkills.map((skill) => {
      if (skill.name === skillName) {
        skill.starCount = skillRating;
      }
      return skill;
    });
  };

  const handleDeleteSkill = () => {
    const skillName = props.skillsData.name;
    const filteredData = removeSkill(props.allSkills, skillName);
    const formattedData = formatSkillData(filteredData);
    if (props.skillsData.skillType === 'highlighted') {
      addHighlightedSkillAPI(formattedData, function (data) {
        handlePopupClose();
        if (data.status_code === 200) {
          props.refreshSkills(filteredData);
        } else {
          alert('Something went wrong');
        }
      });
    }
    if (props.skillsData.skillType === 'selfReported') {
      addSelfReportedSkillAPI(formattedData, function (data) {
        handlePopupClose();
        if (data.status_code === 200) {
          props.refreshSkills(filteredData);
        } else {
          // todo : we need custom alert boxes here
          alert('Something went wrong');
        }
      });
    }
  };

  const handleSaveSkill = () => {
    const skillName = props.skillsData.name;
    const dataToFormat = changeSkillRating(skillName, sliderValue[1]);
    const formattedData = formatSkillData(dataToFormat);
    addSelfReportedSkillAPI(formattedData, function (data) {
      // todo : we need alert boxes
      handlePopupClose(); // close popup
      if (data.status_code === 200) {
        props.refreshSkills(dataToFormat);
      } else {
        alert('Something went wrong');
      }
    });
  };

  return (
    <div className={`popup_div ${isPopupOpen ? 'active' : ''}`}>
      <div className="popup_cont sk">
        <div data-name="followers" className="add_skill_popup">
          <div className="div-block-520">
            <div>Add Skill</div>
            <LiaTimesSolid
              color={GLOBAL_COLORS.icon_color}
              className={'cancel_add_skill'}
              style={{
                height: '16px',
                width: '16px',
              }}
            />
            {/*<img
              src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacfc_close.png"
              loading="lazy"
              alt=""
              className="cancel_add_skill"
            />*/}
          </div>
          <div
            className="div-block-525"
            style={{ display: props.skillsData.starCount ? 'inherit' : 'none' }}
          >
            <div className="div-block-469 sk_s">
              <div className="form-block-15 s_skill w-form">
                <form
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="get"
                  className="form-10"
                  data-wf-page-id="6596f6f119932dba27256924"
                  data-wf-element-id="f31e1962-462b-8b0d-0045-72a4bb8371da"
                  aria-label="Email Form"
                >
                  <div className="div-block-410">
                    <img
                      src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacc8_magnifying-glass.png"
                      loading="lazy"
                      alt=""
                      className="image-164"
                    />
                  </div>
                  <input
                    className="text-field-14 n_text w-input"
                    maxLength={256}
                    name="email-4"
                    data-name="Email 4"
                    placeholder="Search for skills"
                    type="email"
                    id="email-4"
                    required
                  />
                </form>
                <div
                  className="w-form-done"
                  tabIndex={-1}
                  role="region"
                  aria-label="Email Form success"
                >
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div
                  className="w-form-fail"
                  tabIndex={-1}
                  role="region"
                  aria-label="Email Form failure"
                >
                  <div>
                    Oops! Something went wrong while submitting the form.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="popup-f">
            <div className="div-block-475 confirm_add_skill">
              <div className="text-block-284 add_skill_text">Add Skill</div>
            </div>
          </div>
        </div>
        <div data-name="followers" className="skill_report_popup">
          <div className="div-block-520">
            <div>Javascript</div>
            <img
              src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacfc_close.png"
              loading="lazy"
              alt=""
              className="cancel_skill_report"
            />
          </div>
          <div
            className="div-block-525"
            style={{ display: props.skillsData.starCount ? 'inherit' : 'none' }}
          >
            <div className="div-block-469 sk_s">
              <div className="div-block-441">
                <img
                  src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacbd_skills_icon.png"
                  loading="lazy"
                  alt=""
                  className="image-154"
                />
                <div>
                  <div className="text-block-303">Self Rating</div>
                  <div className="text-block-267">Level 3</div>
                  <div className="edit_rating">Edit Rating</div>
                </div>
                <div className="item_options">
                  <div className="item_options_triger">
                    <img
                      src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bac9e_menu.png"
                      loading="lazy"
                      alt=""
                      className="image-182"
                    />
                  </div>
                  <div
                    className="options_div skill_options"
                    style={{ display: 'none' }}
                  >
                    <div className="text-block-238">Clear Rating</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="popup-f">
            <div className="div-block-475 confirm_skill_report">
              <div className="text-block-284 add_skill_text">Save</div>
            </div>
          </div>
        </div>
        <div data-name="followers" className="rate_skill_popup active">
          <div className="div-block-520">
            <div>{`Rate your expertise in "${props.skillsData.name}"`}</div>
            <img
              src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bacfc_close.png"
              loading="lazy"
              alt=""
              onClick={handlePopupClose}
              className="rate_skill_close"
            />
          </div>
          <div
            className="div-block-525"
            style={{ display: props.skillsData.starCount ? 'inherit' : 'none' }}
          >
            <div className="div-block-469 sk_s">
              <div className="rate_skill r_popup">
                <div className="rate_skill_block">
                  <div className="div-block-500">
                    <div className="step_n">1</div>
                    <div className="step_n">2</div>
                    <div className="step_n">3</div>
                    <div className="step_n">4</div>
                    <div className="step_n">5</div>
                  </div>
                  <div className="fs-rangeslider_form w-form">
                    <form
                      id="email-form"
                      name="email-form"
                      data-name="Email Form"
                      method="get"
                      aria-label="Email Form"
                    >
                      {/*<RangeSlider*/}
                      {/*    value={sliderValue}*/}
                      {/*    onChange={handleSliderChange}*/}

                      {/*    className="single-thumb"*/}
                      {/*    thumbsDisabled={[true, false]}*/}
                      {/*    rangeSlideDisabled={true}*/}
                      {/*    showLabel*/}
                      {/*/>*/}

                      <RangeSlider.default
                        id="range-slider-ibl"
                        className="single-thumb"
                        defaultValue={[0, 50]}
                        thumbsDisabled={[true, false]}
                        rangeSlideDisabled={false}
                        onInput={handleSliderChange}
                        value={sliderValue}
                        range={false}
                        min={1}
                        max={5}
                        step={1}
                      />
                    </form>

                    <div
                      className="w-form-done"
                      tabIndex={-1}
                      role="region"
                      aria-label="Email Form success"
                    >
                      <div>Thank you! Your submission has been received!</div>
                    </div>
                    <div
                      className="w-form-fail"
                      tabIndex={-1}
                      role="region"
                      aria-label="Email Form failure"
                    >
                      <div>
                        Oops! Something went wrong while submitting the form.
                      </div>
                    </div>
                  </div>
                  <div className="div-block-468">
                    <div className="text-block-259">Beginner</div>
                    <div className="text-block-259 mgl">Expert</div>
                  </div>
                  <div className="div-block-416">
                    <div className="rate_level">
                      <div className="html-embed-10 rate_level w-embed">
                        <style
                          dangerouslySetInnerHTML={{
                            __html:
                              '\n\n\n\n/*** <--- CIRCLE STYLES ---> ***/\n.wrap-circles {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.circle {\n  position: relative;\n  width: 74px;\n  height: 74px;\n  border-radius: 50%;\n  overflow: hidden;\n}\n.circle.per-25 {\n  background-image: conic-gradient(#369 33%, #def 0);\n}\n\n.circle .inner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60px;\n  height: 60px;\n  background: #fff;\n  border-radius: 50%;\n  font-size: 32px;\n  font-weight: 300;\n  color: #528ac1;\n}\n  ',
                          }}
                        />
                        <div
                          className="circle per-25"
                          style={{
                            backgroundImage:
                              'conic-gradient(#528ac1 30%, #def 0)',
                          }}
                        >
                          <div className="inner">
                            <span>{sliderValue[1]}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-block-263">
                      {selectedSkillDescription}
                    </div>
                    <div className="div-block-503" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="popup-f rate">
            <div
              className="div-block-475 cancel_skill_rate"
              onClick={handlePopupClose}
            >
              <div className="text-block-284 add_skill_text cancel">Cancel</div>
            </div>
            <div
              className="div-block-475 delete-skills"
              onClick={handleDeleteSkill}
            >
              <div className="text-block-284 add_skill_text cancel delete-s">
                Delete skill
              </div>
            </div>
            <div
              className="div-block-475 confirm_skill_rate"
              onClick={handleSaveSkill}
              style={{
                display: props.skillsData.starCount ? 'inherit' : 'none',
              }}
            >
              <div className="text-block-284 add_skill_text">Confirm</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
